import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext.jsx';
import logo from '../../images/logo.webp';

const Header = () => {
  const { isAuthenticated, user, logout } = useAuth();
  const [showDropdown, setShowDropdown] = useState(false);

  const handleLogout = () => {
    logout();
    window.location.href = '/login';
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const closeDropdown = () => {
    setShowDropdown(false);
  };

  return (
    <header className="homepage-header">
      <div className="homepage-nav">
        {/* Logo Section - matching Homepage design exactly */}
        <Link to="/" className="homepage-logo">
          <img src={logo} alt="DevRoom Logo" className="homepage-logo-img" />
          <span className="logo-text">DevRoom</span>
        </Link>

        {/* Auth Buttons Section - matching Homepage design exactly */}
        <div className="homepage-auth-buttons">
          {isAuthenticated ? (
            <>
              <div className="user-dropdown-container">
                <div className="user-avatar-header" onClick={toggleDropdown}>
                  <div className="avatar-circle">
                    <i className="fas fa-user"></i>
                  </div>
                  <div className="dropdown-arrow">
                    <i className={`fas fa-chevron-${showDropdown ? 'up' : 'down'}`}></i>
                  </div>
                </div>
                
                {showDropdown && (
                  <div className="dropdown-menu-enhanced">
                    <div className="dropdown-overlay" onClick={closeDropdown}></div>
                    <div className="dropdown-content">
                      <div className="dropdown-header">
                        <div className="dropdown-avatar">
                          <i className="fas fa-user"></i>
                        </div>
                        <div className="dropdown-user-info">
                          <div className="dropdown-name">{user?.name || 'User'}</div>
                          <div className="dropdown-email">{user?.email || 'user@example.com'}</div>
                        </div>
                      </div>
                      
                      <div className="dropdown-divider"></div>
                      
                      <div className="dropdown-items">
                        <Link to="/profile" className="dropdown-item" onClick={closeDropdown}>
                          <div className="item-icon">
                            <i className="fas fa-user"></i>
                          </div>
                          <span className="item-text">View Profile</span>
                        </Link>
                        
                        <Link to="/update-password" className="dropdown-item" onClick={closeDropdown}>
                          <div className="item-icon">
                            <i className="fas fa-lock"></i>
                          </div>
                          <span className="item-text">Change Password</span>
                        </Link>
                        
                        <div className="dropdown-divider"></div>
                        
                        <button onClick={handleLogout} className="dropdown-item logout-item">
                          <div className="item-icon">
                            <i className="fas fa-sign-out-alt"></i>
                          </div>
                          <span className="item-text">Log Out</span>
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </>
          ) : (
            <>
              <Link to="/login" className="btn-outline">Login</Link>
              <Link to="/register" className="btn-primary-nav">Register</Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;